import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function Settings() {
  const [me, setMe] = useState<{ email: string; isAdmin: boolean; via?: string } | null>(null);

  useEffect(() => {
    api.me().then((r) => setMe(r.user)).catch(() => setMe(null));
  }, []);

  async function logout() {
    await fetch('/api/auth/logout', { method: 'POST' });
    location.href = '/login';
  }

  return (
    <div className="space-y-6 max-w-3xl">
      <h1 className="text-2xl font-semibold tracking-tight">Settings</h1>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Signed in as</CardTitle>
        </CardHeader>
        <CardContent>
          {me ? (
            <div className="flex items-start justify-between gap-4">
              <div className="space-y-1">
                <div className="font-mono text-sm">{me.email}</div>
                <div className="text-xs text-muted-foreground">
                  Admin: {me.isAdmin ? 'yes' : 'no'}
                  {me.via ? ` · via ${me.via}` : ''}
                </div>
              </div>
              <Button variant="outline" size="sm" onClick={logout}>
                Sign out
              </Button>
            </div>
          ) : (
            <div className="text-sm text-muted-foreground">Not authenticated.</div>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Global notification settings</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-muted-foreground">
          <p>
            Set the default email and Slack webhook via <code className="font-mono">wrangler secret put</code>:
          </p>
          <pre className="rounded bg-muted p-3 text-xs font-mono">
{`wrangler secret put RESEND_API_KEY
wrangler secret put SLACK_WEBHOOK_URL`}
          </pre>
          <p>
            Per-monitor overrides live on each monitor's edit page.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">About</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground space-y-1">
          <div>PX7 Uptime Monitor · v0.1.0</div>
          <div>Runs on Cloudflare Workers, D1, Durable Objects, KV, Analytics Engine.</div>
        </CardContent>
      </Card>
    </div>
  );
}
